import { mapState } from 'vuex';
import api from '@/api';

let typingTimer = null;

export const resumeOptimizationMixin = {
  data() {
    return {
      displayedText: '',
      currentCharIndex: 0,
      typingSpeed: 100,
      typing: false,
      optimizationStatus: 'initial',
      optimizationResult: '',
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    isMemberAccount() {
      return this.personInfo.is_membership;
    },
  },
  methods: {
    closeOptimization() {
      this.optimizationStatus = 'initial';
      this.optimizationResult = '';
      this.displayedText = '';
      this.currentCharIndex = 0;
      this.typing = false;
      clearTimeout(typingTimer);
    },
    startTyping(fullText) {
      if (!fullText) return;
      if (this.currentCharIndex < fullText.length) {
        this.typing = true;
        this.displayedText += fullText[this.currentCharIndex];
        this.currentCharIndex++;
        this.optimizationResult = this.displayedText;
        this.optimizationStatus = 'over';
        typingTimer = setTimeout(() => this.startTyping(fullText), this.typingSpeed);
      } else {
        this.typing = false;
      }
    },
    async handleClickAiOptimization(description) {
      try {
        this.optimizationStatus = 'loading';

        if (!this.isMemberAccount) {
          setTimeout(() => {
            this.optimizationResult = '';
            this.optimizationStatus = 'over';
          }, 500);
        } else {
          const res = await api.AI.getAIOptimizationResult({
            text: description,
          });

          if (res.code === 2030) {
            this.optimizationStatus = !!this.optimizationResult ? 'over' : 'initial';
            return this.$message.error('AI简历润色次数不足');
          }

          if (res.code === 1000) {
            this.displayedText = '';
            if (res.data.result) {
              this.startTyping(res.data.result);
            } else {
              this.optimizationStatus = 'error';
              this.optimizationResult = '';
            }
          } else {
            this.optimizationStatus = 'error';
            this.optimizationResult = '';
          }
        }
      } catch (error) {
        this.optimizationStatus = 'error';
        this.optimizationResult = '';
        console.log(error, 'error');
      }
    },
    async clickAiOptimization(item) {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: '温馨提示',
          content: '为了保证润色效果，建议您将内容写完整后再润色哦～',
          confirmText: '确认润色',
          cancelText: '我再想想',
        });
        if (confirm) {
          this.$emit('editItem', item.id);
          this.handleClickAiOptimization(item.description);
          this.changeAdviceType('optimization');
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
  },
};
